import React, { forwardRef } from "react";
import Input from "../../AtomicInput";
import { css, cx } from "emotion";
import ErrorMessage from "../ErrorMessage";
import { defaultStyle } from "./style";
import { scrollToComponent } from "../../../js/shared/utils";

const InputFormRef = ({
	errorMessage,
	hasError,
	innerRef,
	helperText,
	icon,
	onClick,
	noScroll,
	...rest
}) => {
	const onClickScroll = ev => {
		const { id } = rest;
		if (!noScroll && id) {
			scrollToComponent(`#${id}`, 100, true, true);
		}

		if (onClick) {
			onClick(ev);
		}
	};

	return (
		<div
			className={cx(
				css`
					${defaultStyle}
				`,
				"form-group",
				{ "has-error": hasError }
			)}
		>
			<Input {...rest} ref={innerRef} hasError={hasError} onClick={onClickScroll} />
			{errorMessage && hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
			{helperText}
			{icon}
		</div>
	);
};

const InputForm = forwardRef((props, ref) => <InputFormRef {...props} innerRef={ref} />);

export default InputForm;
